import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AdminCase } from "../models";
import { WriteResource } from "../types";
import { RootState } from "../store";
import { removeCaseHoldApi } from "../api";

export interface RemoveHoldCaseForm {
  readonly case: AdminCase;
  readonly reasonForChange: string | null;
}

export type RemoveHoldCaseDialogState =
  | {
      readonly isOpen: true;
      readonly case: WriteResource<RemoveHoldCaseForm, AdminCase>;
    }
  | {
      readonly isOpen: false;
    };

// thunks
export const caseRemoveHold = createAsyncThunk(
  "removeHoldCaseDialog/caseRemoveHold",
  async (_: void, thunkApi) => {
    const { getState } = thunkApi;
    const rootState = getState() as RootState;
    const state = rootState.removeHoldCaseDialog;

    if (state.isOpen) {
      await removeCaseHoldApi(state.case.data.case.id, state.case.data.reasonForChange || "");
    }
  }
);

export const removeHoldCaseDialogSlice = createSlice({
  name: "removeHoldCaseDialog",
  initialState: { isOpen: false } as RemoveHoldCaseDialogState,
  reducers: {
    openRemoveHoldCaseDialog: (state, action) => {
      return {
        isOpen: true,
        case: {
          data: {
            case: action.payload,
            reasonForChange: null
          }
        }
      };
    },
    closeRemoveHoldCaseDialog: state => {
      state.isOpen = false;
    },
    setRemoveHoldCaseForm: (state, action) => {
      if (state.isOpen) {
        state.case = {
          data: action.payload
        };
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(caseRemoveHold.fulfilled, () => {
      return { isOpen: false } as RemoveHoldCaseDialogState;
    });
    builder.addCase(caseRemoveHold.rejected, (state, action) => {
      if (state.isOpen) {
        state.case = {
          data: state.case.data,
          errorMessage: action.error.message
        };
      }
    });
  }
});

export const {
  openRemoveHoldCaseDialog,
  closeRemoveHoldCaseDialog,
  setRemoveHoldCaseForm
} = removeHoldCaseDialogSlice.actions;
export default removeHoldCaseDialogSlice.reducer;
